import { render, staticRenderFns } from "./rfp-list.vue?vue&type=template&id=b28dcd26&scoped=true&"
import script from "./rfp-list.vue?vue&type=script&lang=js&"
export * from "./rfp-list.vue?vue&type=script&lang=js&"
import style0 from "./rfp-list.vue?vue&type=style&index=0&id=b28dcd26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28dcd26",
  null
  
)

export default component.exports